import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

import { PdfSettings } from '~/components/settings/admin/pdf/PdfSettings';

export const Route = createFileRoute('/(main)/settings/admin/pdf-settings/')({
  component: PdfSettings,
});

export const ADMIN_PDF_SETTINGS = buildRouteExport({
  Route,
});
